// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2jOWA","row":"ProcedureTreatmentSummary_row__FWIFC"};